// LICENSE_CODE ZON
'use strict'; /*jslint node:true, es6:true, react:true*/
import {useEffect} from 'react';
import {useLocation, useHistory} from 'react-router-dom';
import {use_qs} from './use_qs';

export const use_persist_debug_param = ()=>{
    const location = useLocation();
    const history = useHistory();
    useEffect(()=>{
        const params = new URLSearchParams(location.search);
        const debug_params = new Map();
        for (const [key, value] of params.entries())
        {
            if (key.startsWith('debug_'))
                debug_params.set(key, value);
        }
        if (debug_params.size > 0)
        {
            const unlisten = history.listen(new_location=>{
                const new_params = new URLSearchParams(new_location.search);
                let modified = false;
                for (const [key, value] of debug_params.entries())
                {
                    if (!new_params.has(key))
                    {
                        new_params.set(key, value);
                        modified = true;
                    }
                }
                if (modified)
                {
                    history.replace({
                        ...new_location,
                        search: new_params.toString(),
                    });
                }
            });
            return ()=>unlisten();
        }
    }, [location.search, history]);
};

export const use_debug_ui = (value = '1')=>{
    const qs = use_qs();
    return qs.debug_ui?.includes(value);
};

export const is_debug_ui = (flag_name: string)=>
    new URLSearchParams(window.location.search).get('debug_ui')==flag_name;
